import * as React from "react";
import { List, ListItem, CircularProgress, Grid, Typography, FormControlLabel, Box, useMediaQuery } from "@mui/material";
import { Stack } from "@mui/system";
import styles from "./ChartDialogCommon.module.scss";
import CheckboxButton from "../../dashboard/shared/checkboxButton/CheckboxButton";
import { Checkbox } from "@mui/material";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';

export default function ChartDialogLeftSidebar({
    loading,
    filterData,
    selectedItem,
    title,
    subtitle,
    handleToggle,
    handleToggleAll,
    isFilterList = true,
    isExpanded = false,
    onToggleExpand,
    allowSpecialItemSelection = false, // Enable selection for special items (e.g., average items) when true
}) {
    const [selectAll, setSelectAll] = React.useState(false);
    const isMobile = useMediaQuery('(max-width: 768px)');

    const toggleAll = async (e) => {
        setSelectAll(e.target.checked);
        handleToggleAll(e.target.checked ? "all" : "unSelectAll")
    };

    React.useEffect(() => {
        if (filterData?.length > 0 && selectedItem?.length > 0 && filterData.length === selectedItem.length) {
            setSelectAll(true)
        } else if (!filterData?.length || !selectedItem?.length) {
            setSelectAll(false)
        }
    }, [filterData, selectedItem]);

    return (
        <Grid
            item
            className={styles.leftPanel}
            sx={{
                transition: 'all 1.5s cubic-bezier(0.4, 0, 0.6, 1)',
                overflow: 'hidden',
                height: '100%',
                maxHeight: '100%',
                alignSelf: 'stretch',
                display: 'flex',
                flexDirection: 'column',

                ...(!isMobile && {
                    flexBasis: '10.83%',
                    maxWidth: '10.83%',
                }),

                ...(isMobile && {
                    ...(isExpanded && {
                        flexBasis: '37.5%',
                        maxWidth: '37.5%',
                        opacity: 1,
                        transform: 'translateX(0)',
                        p: 1,
                    }),
                    ...(!isExpanded && {
                        flexBasis: '0px',
                        maxWidth: '0px',
                        minWidth: '0px',
                        opacity: 0,
                        transform: 'translateX(-100%)',
                        p: 0,
                    }),
                }),
            }}
        >
            <Stack direction={"row"} className={styles.header} sx={{ position: 'relative', flexShrink: 0 }}>
                <div style={{
                    ...(isMobile && !isExpanded && {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: 'calc(100% - 40px)',
                        fontSize: '12px'
                    })
                }}>
                    {title}
                </div>
                {subtitle && (
                    <div style={{
                        ...(isMobile && !isExpanded && {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            maxWidth: 'calc(100% - 40px)',
                            fontSize: '10px'
                        })
                    }}>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                ...(isMobile && !isExpanded && {
                                    fontSize: '10px',
                                    lineHeight: 1.2
                                })
                            }}
                        >
                            {subtitle}
                        </Typography>
                    </div>
                )}
                {isMobile && isExpanded && (
                    <Box
                        onClick={onToggleExpand}
                        sx={{
                            position: 'absolute',
                            right: '8px',
                            top: '40%',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            borderRadius: '50%',
                            width: '20px',
                            height: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1px solid rgba(0, 0, 0, 0.1)',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                            cursor: 'pointer',
                            zIndex: 1
                        }}
                    >
                        <KeyboardArrowLeftIcon
                            sx={{ fontSize: 12, color: '#1976d2' }}
                        />
                    </Box>
                )}
            </Stack>
            {!loading && filterData?.length > 0 && isFilterList && (
                <>
                    <Stack direction={"row"} sx={{ flexShrink: 0 }}>
                        <Box sx={{
                            padding: isMobile ? "0px" : "12px 20px 0px 15px",
                            ml: isMobile ? "0px" : "12px",
                            borderBottom: isMobile ? "1px solid rgba(0, 0, 0, 0.08)" : "none",
                            marginBottom: isMobile ? "8px" : "0px",
                            ...(isMobile && {
                                mt: "-10px",
                                height: "60px",
                                width: "100%",
                                justifyContent: "center",
                                alignItems: "center"
                            })
                        }}>
                            <FormControlLabel
                                control={<Checkbox
                                    onChange={toggleAll}
                                    checked={selectAll}
                                    sx={{
                                        ...(isMobile && {
                                            '& .MuiSvgIcon-root': {
                                                fontSize: 18,
                                            }
                                        })
                                    }}
                                />}
                                label={isExpanded ? <Typography
                                    fontSize={isMobile ? 13 : 14}
                                    sx={{
                                        ...(isMobile && {
                                            fontWeight: 500,
                                            lineHeight: 1.3
                                        })
                                    }}
                                >
                                    Select / Clear All
                                </Typography> : isMobile ? "" : "Select / Clear All"}
                            />
                        </Box>
                    </Stack>
                    <Stack
                        direction={"row"}
                        className={styles.listScrollArea}
                        sx={{
                            mt: "0px",
                            flex: 1,
                            minHeight: 0,
                            ...(isMobile && !isExpanded && {
                                overflowX: "hidden",
                            })
                        }}
                    >
                        <List className={styles.itemsWrpr}>
                            {filterData?.length > 0 &&
                                filterData.map((item) => {
                                    const labelId = `checkbox-list-dialog-button-label-${item._id}`;
                                    const selected = selectedItem?.indexOf(item._id) !== -1;
                                    return (
                                        <ListItem
                                            key={labelId}
                                            className={`${styles.sec} ${selected ? styles.selected : null}`}
                                            id={labelId}
                                            sx={{
                                                ...(isMobile && !isExpanded && {
                                                    padding: "0px 0px !important",
                                                    height: "30px",
                                                    margin: "8px 0px !important",
                                                    width: "100%",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                })
                                            }}
                                        >
                                            <CheckboxButton
                                                isSpacialItem={item?.isSpacialItem}
                                                labelId={labelId}
                                                handleToggle={() => handleToggle(item._id)}
                                                checked={selectedItem?.indexOf(item._id) !== -1}
                                                buttonText={!isMobile ? item.label : isExpanded ? `${item.label}` : ``}
                                                allowSpecialItemSelection={allowSpecialItemSelection}
                                                sx={{
                                                    ...(isMobile && {
                                                        '& .MuiSvgIcon-root': {
                                                            fontSize: 20,
                                                            ...(!isExpanded && {
                                                                marginLeft: "10px !important",
                                                            })
                                                        }
                                                    })
                                                }}
                                            />
                                        </ListItem>
                                    );
                                })}
                        </List>
                    </Stack>
                </>
            )}
            {loading && (
                <Stack
                    direction={"row"}
                    sx={{ alignItems: "center", justifyContent: "center", mt: 4 }}
                >
                    <CircularProgress />
                </Stack>
            )}
        </Grid>
    );
}
